import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { FavoritesRefreshEvent } from 'src/app/models/events/favorites-refresh-event';

@Injectable({
    providedIn: 'root',
})
export class FavoritesEventsService {
    /**
     * Emis lorsque la section doit être rechargée.
     */
    public needRefresh = new Subject<FavoritesRefreshEvent>();
}
